export type Fraktion = "mitte" | "nord" | "eimsbuettel" | "altona" | "harburg";

export const FRAKTIONEN: ReadonlyArray<{ value: Fraktion; label: string }> = [
  { value: "mitte", label: "Mitte" },
  { value: "nord", label: "Nord" },
  { value: "eimsbuettel", label: "Eimsbüttel" },
  { value: "altona", label: "Altona" },
  { value: "harburg", label: "Harburg" },
];

export const getFraktionLabel = (value?: Fraktion | null): string =>
  FRAKTIONEN.find((f) => f.value === value)?.label ?? "";
